import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Ligas disponíveis em linha */}
        <div className="footer-leagues">
          <h3>🏆 Ligas Disponíveis</h3>
          <div className="leagues-row">
            <span>🇬🇧 Premier League</span>
            <span>🏴 Championship</span>
            <span>🇫🇷 Ligue 1</span>
            <span>🇳🇴 Eliteserien</span>
            <span>🇮🇹 Serie A</span>
            <span>🇩🇪 Bundesliga</span>
            <span>🇵🇹 Liga Portugal Betclic</span>
            <span>🇧🇷 Brasileirão Série A</span>
            <span>🇧🇷 Brasileirão Série B</span>
            <span>🇦🇷 Liga Profesional</span>
            <span>🏆 Champions League</span>
            <span>🌍 Europa League</span>
            <span>🏆 Copa Libertadores</span>
            <span>🇪🇸 La Liga</span>
          </div>
        </div>

        {/* Sugestões */}
        <div className="footer-suggestions">
          <h3>💡 Sugestões</h3>
          <p>
            Envie suas ideias para melhorar o projeto:{" "}
            <strong>pro.scanners.pro@gmail.com</strong>
          </p>
        </div>
      </div>

      <p className="footer-warning">
       <h6> ⚠️  O ScannerPro é destinado a apostadores profissionais. Seja responsável.</h6> 
      </p>
    </footer>
  );
}
